/**
 * 默认表格列 - 组织计费信息
 */
export const defaultBillingInfoListTableColumns = ["付费通道", "开始时间", "到期时间", "更新时间"];
